<template>
  <div class="search-form">

  <div class="search-blck-title" :id="'search-blck-'+post_id"><img class="search-icon" src="./../assets/icons/search.png" alt="search review" title="search review"/>Search</div>


    <div v-if="parsedSearchResponseShow.length>0" class="search-results-blck">
         <div v-for="result in parsedSearchResponseShow" :key="result">
          <div v-for="item in result" :key="item">
           <div v-if="item.id>0">
            <a :href="'../reviews/?p='+item.id" :title="item.title" :alt="item.title" class="search-link">
             <div class="search-title">
               {{ item.title }}
             </div>
            </a> 
           </div>
           <div v-if="item.id==0 && parsedSearchResponseShow.length==1" class="search-title-noresult">
               No results
           </div>    
           <div v-if="item.id==0 && parsedSearchResponseShow.length>1" class="search-title-noresult">
               This search didn't return new results.<br>Please try to rephrase.
           </div>    


          </div>
        </div> 
    </div>

    

    <div class="search-form-inputs">
     <div class="search-form-inputs-1"> 
      <label class="visually-hidden keyword-1" :id="'kw1-label-'+post_id" :for="'search-kw1-'+post_id">Search by product name or title</label>  
      <input type="text" class="search-input" :id="'search-kw1-'+post_id" @focusin="labelOneFade(post_id)" @focusout="labelOneUnfade(post_id)"/>
     </div>
     <div class="search-form-inputs-2"> 
      <label class="visually-hidden  keyword-2" :id="'kw2-label-'+post_id" :for="'search-kw2-'+post_id">*optional: brand, model, location</label>  
      <input type="text" class="search-input" :id="'search-kw2-'+post_id" @focusin="labelTwoFade(post_id)" @focusout="labelTwoUnfade(post_id)"/>
     </div>
      <button class="search-button" @click="doSearch(post_id,parsedSearchResponseShow)"><img class="search-icon-button" src="./../assets/icons/search_wh.png" alt="search review" title="search review"/>search</button>
    </div>
   
  </div>
</template>

<script>
import {fade,unfade} from '@/assets/js/global.js'
import {scrollBy} from 'seamless-scroll-polyfill'
import {ref} from 'vue'

export default {
  name: "SearchBlock",
  props: ['post_id'],
  data() {
    return {
      postId: this.post_id
    };
  },
  setup(){
    let parsedSearchResponseShow = ref([])
    

    return {
         parsedSearchResponseShow
    }
  },
  methods: {
    doSearch: async(post_id,parsedSearchResponseShow) => {

        

        let searchFromTop = document.getElementById('search-blck-'+post_id).getBoundingClientRect().top
        let menuHeight = document.querySelector('.top-menu').getBoundingClientRect().height


        let kwInputOne = document.getElementById('search-kw1-'+post_id)
        let kwInputTwo = document.getElementById('search-kw2-'+post_id)

        let kw1 = kwInputOne.value
        let kw2 = kwInputTwo.value


        //let searchResponse = await fetch('https://www.reviewstream.com/reviews/api/search.php?q='+kw1+'&qq='+kw2)
        let searchResponse = await fetch('../reviews/api/search.php?q='+kw1+'&qq='+kw2)

        let parsedSearchResponse = await searchResponse.json()
        let searchResult = parsedSearchResponse

        if(parsedSearchResponseShow.flat().some(item => item.id == '0')){
            parsedSearchResponseShow.splice(parsedSearchResponseShow.flat().findIndex(item => item.id == "0"), 1)
        }

        if(Object.values(searchResult).indexOf('0') == -1){
            parsedSearchResponseShow.unshift(parsedSearchResponse)
            scrollBy(window, { behavior: "smooth", block: "start", top: (searchFromTop - menuHeight*2.5) })
        }
        else{
            parsedSearchResponseShow.push(parsedSearchResponse)
        }

      },
      labelOneFade(post_id){
         let label = document.getElementById('kw1-label-'+post_id) 
         let inputTxt = document.getElementById('search-kw1-'+post_id).value
         if(!inputTxt){
           fade(label)
         }  
      },
      labelOneUnfade(post_id){
         let label = document.getElementById('kw1-label-'+post_id) 
         let inputTxt = document.getElementById('search-kw1-'+post_id).value
         if(!inputTxt){
           unfade(label)
         }  
      },
      labelTwoFade(post_id){
         let label = document.getElementById('kw2-label-'+post_id) 
         let inputTxt = document.getElementById('search-kw2-'+post_id).value
         if(!inputTxt){
           fade(label)
         }
      },
      labelTwoUnfade(post_id){
         let label = document.getElementById('kw2-label-'+post_id) 
         let inputTxt = document.getElementById('search-kw2-'+post_id).value
         if(!inputTxt){
           unfade(label)
         }  

      }

  }    


}
</script>

<style scoped>
.search-form{
    position:relative;
    width:100%;
    font-family: "Roboto";
    margin-bottom: 30px;
}
.search-form-inputs{
    width:100%;
    height:185px;
    display:inline-block;
}
.search-form-inputs-1{
    position:relative;
    width:100%;
    display:inline-block;
}
.search-form-inputs-2{
   position:relative; 
   width:100%; 
   display:inline-block;
}
.search-button{
    width:100%;
    height:50px;
    border-radius:10px;
    background-color:#192f97;
    border:1px solid #192f97;
    color:#ffffff;
    font-size:1.7em;
    cursor:pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
}
.search-results-blck{
        border-left: 2px solid #E15611;
        margin-top: 20px;
        margin-bottom:20px;
}
.search-icon-button{
    width: 40px;
    height:40px;
    margin-right: 20px;
}
.search-input{
    width: 100%;
    padding: 0;
    height:50px;
    border:1px solid #333;
    border-radius:10px;
    margin-bottom:10px;
    background-color:#ffffff;
    color:#444;
    font-size: 22px;
    padding-left: 10px;
    box-sizing: border-box;
}
.visually-hidden {
  border-width: 0 !important;
  height: 1px !important;
  padding: 0 0 0 10px !important;
  position: absolute !important;
  white-space: nowrap !important;
  width: 1px !important;
  color: #999;

}
.keyword-1{
    font-size: 18px;
    top: 35%;
    font-family: arial;
}
.keyword-2{
    font-size: 16px;
    top: 40%;
    left: 0;
    font-family: arial;
}
.search-result-blck{
        border-left: 2px solid #E15611;
        margin-top: 20px;
}
.search-link{
    text-decoration:none;
}
.search-title{
    font-size: calc(12px + 0.3vw + 0.3vh);
    line-height: 35px;
    font-family: arial;
    margin: 0 8px;
    color: #444;
    padding: 5px 0;
    border-bottom: 2px solid #ffffff;    
}
.search-title-noresult{
    font-size: calc(12px + 0.6vw + 0.6vh);
    line-height: 35px;
    font-family: 'PT Serif';
    margin: 0 8px 10px 8px;
    color:#E15611; 
    padding: 10px 0;
}


@media (min-width: 768px) {
.search-title:hover{
    border-bottom-color:#E15611;
  }
}

</style>
